import {useEffect, useState} from "react";

export const useScreenSize = () => {
    const [isScreenLessThan360, setIsScreenLessThan360] = useState(window.innerWidth < 360);
    const [isScreenLessThan600, setIsScreenLessThan600] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => {
            setIsScreenLessThan360(window.innerWidth < 360);
            setIsScreenLessThan600(window.innerWidth < 600);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {isScreenLessThan360, isScreenLessThan600}
}